import { DOCUMENT, Inject, Injectable, effect, signal } from '@angular/core';
import { FikoYTService } from '../../../service/fikoyt.service';

@Injectable({
  providedIn: 'root'
})
export class ServisUyarService {
  logoBuyukUrl = signal("./app/uyar/uyar.png");
  /** */
  solMenuAcik = signal(true);
  /** */
  solMenu = signal([
    {
      level: 1,
      title: '👑 Yönetici Konsolu',
      // icon: 'dashboard',
      open: true,
      selected: false,
      disabled: false,
      routerLink: ['/🧩', '🌀', '👑'],
      nzMatchRouter: true,
      children: null,
      yetkiler: ['Süper Yönetici'],
    },
    {
      level: 1,
      title: '🤖 Uyar Merkez',
      // icon: 'dashboard',
      open: true,
      selected: false,
      disabled: false,
      routerLink: ['/🧩', '🌀', '🤖'],
      nzMatchRouter: true,
      children: null,
    },
    {
      level: 1,
      title: '🎛 Ana Pano',
      routerLink: '/🧩/🌀/🎛',
      nzMatchRouter: true,
      open: true,
      children: null,
    },
    {
      level: 1,
      title: '🏭 Firmalar',
      // icon: 'dashboard',
      open: true,
      selected: false,
      disabled: false,
      routerLink: ['/🧩', '🌀', '🏭'],
      nzMatchRouter: true,
      children: null,
    },
    {
      level: 1,
      title: '💍 Teklifler',
      // icon: 'apartment',
      routerLink: '/🧩/🌀/💍',
      nzMatchRouter: true,
      open: true,
      children: null,
    },
    {
      level: 1,
      title: '📋 Siparişler',
      // icon: 'shopping-cart',
      routerLink: '/🧩/🌀/📋',
      nzMatchRouter: true,
      open: true,
      children: null,
    },
    {
      level: 1,
      title: '🧼 Straforlar',
      // icon: 'apartment',
      routerLink: '/🧩/🌀/🧼/🎛',
      nzMatchRouter: true,
      open: true,
      children: null,
    },
    {
      level: 1,
      title: '📱 KareKod Takip',
      // icon: 'qrcode',
      routerLink: '/🧩/🌀/📱/🎛',
      nzMatchRouter: true,
      open: true,
      children: null,
    },
    {
      level: 1,
      title: '📦 Stoklar',
      // icon: 'apartment',
      routerLink: '/🧩/🌀/📦',
      nzMatchRouter: true,
      open: false,
      // children: [
      //   {
      //     level: 2,
      //     title: '🤖️ Pano',
      //     // icon: 'dashboard',
      //     open: false,
      //     selected: false,
      //     disabled: false,
      //     routerLink: '/🧩/🌀/📦/🤖',
      //     nzMatchRouter: true,
      //     children: null,
      //   },
      //   {
      //     level: 2,
      //     title: '📜 Liste',
      //     // icon: 'stock',
      //     routerLink: '/🧩/🌀/📦/📜',
      //     nzMatchRouter: true,
      //     children: null
      //   },
      //   {
      //     level: 2,
      //     title: '♻️ Stok Hareketleri',
      //     routerLink: '/🧩/🌀/📦/♻️',
      //     nzMatchRouter: true,
      //     children: null
      //   },
      // ]
    },
    {
      level: 1,
      title: '🧬 PDKS',
      // icon: 'apartment',
      open: false,
      children: [
        {
          level: 2,
          title: '🤖️ Pano',
          // icon: 'dashboard',
          open: false,
          selected: false,
          disabled: false,
          routerLink: ['/🥘', '🧬', '🤖'],
          nzMatchRouter: true,
          children: null,
        },
        {
          level: 2,
          title: '🌀 Vardiyalar',
          // icon: 'stock',
          routerLink: ['/🥘', '🧬', '🌀'],
          nzMatchRouter: true,
          children: null
        },
        {
          level: 2,
          title: '🔨 Çalışanlar',
          // icon: 'stock',
          routerLink: ['/🥘', '🧬', '🔨'],
          nzMatchRouter: true,
          children: null
        },
        {
          level: 2,
          title: '🔀 Hareketler',
          routerLink: ['/🥘', '🧬', '🔀'],
          nzMatchRouter: true,
          children: null
        },
      ]
    },
    {
      level: 1,
      title: '✨ Projeler',
      routerLink: '/🧩/🌀/✨/🤖',
      nzMatchRouter: true,
      // icon: 'apartment',
      open: false,
      // children: [
      //   {
      //     level: 2,
      //     title: '🤖️ Pano',
      //     // icon: 'dashboard',
      //     open: true,
      //     selected: false,
      //     disabled: false,
      //     routerLink: '/🧩/🌀/✨/🤖',
      //     nzMatchRouter: true,
      //     children: null,
      //   },
      //   {
      //     level: 2,
      //     title: '📜 Liste',
      //     // icon: 'stock',
      //     routerLink: '/🧩/🌀/✨/📜',
      //     nzMatchRouter: true,
      //     children: null
      //   },
      //   {
      //     level: 2,
      //     title: '📊 Proje Hareketleri',
      //     routerLink: ['/🥘', '🏗️', '📊'],
      //     nzMatchRouter: true,
      //     children: null
      //   },
      // ]
    },
    {
      level: 1,
      title: '🧃 Hibrit Uygulamalar',
      // icon: 'apartment',
      open: true,
      children: [
        {
          level: 2,
          title: '🛰 Post Birleştirici',
          // icon: 'dashboard',
          open: false,
          selected: false,
          disabled: false,
          routerLink: '/🧩/🌀/🧃/🎛',
          nzMatchRouter: true,
          children: null,
        },
        {
          level: 2,
          title: '👩‍💻 Post Processor',
          // icon: 'dashboard',
          open: false,
          selected: false,
          disabled: false,
          routerLink: '/🧩/🌀/🧃/👩‍💻',
          nzMatchRouter: true,
          children: null,
        },
        {
          level: 2,
          title: '🔬 STEP Analizörü',
          // icon: 'experiment',
          open: false,
          selected: false,
          disabled: false,
          routerLink: '/🧩/🌀/🧃/🔬',
          nzMatchRouter: true,
          children: null,
        },
        {
          level: 2,
          title: '🎯 Floating Toolbar Demo',
          // icon: 'build',
          open: false,
          selected: false,
          disabled: false,
          routerLink: '/🧩/🌀/🧃/🎯',
          nzMatchRouter: true,
          children: null,
        },
      ]
    },
  ]);
  /** */


  constructor(public FikoYT: FikoYTService,@Inject(DOCUMENT) private document: Document) {
    this.FikoYT.ayarlar.getByPrimaryKey("uyar-solMenuAcik", (item) => {
      this.solMenuAcik.set(item as boolean);
    });

    effect(() => {
      this.FikoYT.ayarlar.ekleYadaGuncelleTek(this.solMenuAcik(), "uyar-solMenuAcik").then();
      // Drawer açıldığında CDK sınıfını kaldır
      setTimeout(() => {
        const el = this.document.documentElement;
        const body = this.document.body;
        el.classList.remove('cdk-global-scrollblock');
        body.classList.remove('cdk-global-scrollblock');
      }, 10);
    });
  }
}

